import { FC } from 'react';

import { isNonNullish } from 'remeda';
import useSWR from 'swr';

import { CreateUserGuideFrom } from './createUserGuideForm/CreateUserGuideFrom';
import { UserGuidesTable } from './userGuidesTable/UserGuidesTable';
import { UserGuideStatistics } from './userGuideStatistics/UserGuideStatistics';

import css from './UserGuidePage.module.css';

import { userGuideService } from 'v2/api/userGuideService';
import { Loader } from 'v2/components/loader/Loader';
import { PageLayout } from 'v2/components/pageLayout/PageLayout';
import { PageTitle } from 'v2/components/pageLayout/pageTitle/PageTitle';
import { usePagination } from 'v2/hooks/usePagination';

export const UserGuidePage: FC = () => {
  const pagination = usePagination();

  const { data, isLoading, mutate } = useSWR(
    ['getGuides', pagination.page, pagination.pageSize],
    userGuideService.getGuides
  );

  return (
    <PageLayout className={css.userGuidePage} overflow="hidden">
      <PageTitle action={<UserGuideStatistics />}>User Guide Settings</PageTitle>

      <div className={css.userGuidePageContent}>
        <CreateUserGuideFrom onSuccess={mutate} />

        {isLoading ? (
          <Loader />
        ) : (
          isNonNullish(data) && <UserGuidesTable data={data} pagination={pagination} onRevalidate={mutate} />
        )}
      </div>
    </PageLayout>
  );
};
